<template>


    <!--    results-->
    <div class="container-fluid" v-if="ready ">
        <div class="row">
            <aside class="filters px-0 mb-4 mb-lg-0" ref="filtersPanel">
                <div class="filters-options d-flex justify-content-between align-items-center">
                    <button class="filters-toggle filters-toggle-btn "
                            ref="btnToggleFilters"
                            @click="toggleFiltersOpen"
                            :aria-label=" openCloseFiltersText "
                    >
                        <i class="fa-light fa-sliders" aria-hidden="true"></i>
                        <h2 class="filter-toggle-label ms-2">{{
                                copydeck?.search?.filters?.fr ?? 'copydeck?.search?.filters?.fr'
                            }}</h2>
                    </button>

                    <div class="d-flex align-items-center">
                        <button type="button" class="filters-reset"
                                aria-label="Effacer tous les filtres sélectionnés"
                                @click="resetFilters">
                            {{ copydeck?.search?.effacer_tout?.fr ?? 'copydeck?.search?.effacer_tout?.fr' }}
                        </button>
                    </div>
                </div>
                <div class="filters-container">
                    <h3 class="category-filters-heading">Catégorie</h3>
                    <Filter
                        v-for="(category, index) in allFilters.categories ?? [] "
                        :key="category.id"
                        :value="category.id"
                        :id="'category-filter_'+ category.id"
                        :info="category"
                        :name="'categories-filters[]'"
                        :check="category.active"
                        filterType="categories"
                        ref="elCategoryFilters"
                        @changedFilters="filterArticles"
                    />

                    <h3 class="category-filters-heading">Date</h3>
                    <Filter
                        v-for="(dateFilter, index) in  allFilters.dates ?? []"
                        :key="dateFilter.criteria"
                        :value="dateFilter.value"
                        :info="dateFilter"
                        :name="'date-filters[]'"
                        :checked="dateFilter.active"
                        :id="'date-filter_' + dateFilter.id"
                        ref="elDateFilters"
                        filterType="dates"
                        @changedFilters="filterArticles"
                    />
                </div>
                <div class="filters-results d-flex d-xl-none justify-content-center">
                    <button class="filters-toggle-btn btn-rounded btn-color-blue"
                            @click="toggleFiltersOpen"
                    >

                    <span
                        v-if="numArticles === 0"
                        v-html="copydeck?.search?.noResultsFoundTitle?.fr ?? 'copydeck?.search?.noResultsFoundTitle?.fr' "
                    ></span>


                        <span v-if="numArticles > 0">
                            <span class="value">{{ numArticles }}</span>
                            <span class="unit">{{ articlesPluralSingularWord }}</span>
                        </span>

                    </button>
                </div>
            </aside>


            <div class="search-results">
                <div class="container">
                    <section class="results-section">
                        <div class="d-md-flex justify-content-between justify-content-xl-end top-row">
                            <h1 class="page-title">Actualités</h1>


                            <div
                                class="list-options d-flex align-items-center justify-content-between-md display-options">

                                <div class="list-mode-group d-none d-md-block">
                                    <input type="radio" id="list-mode-layout_grid" name="list-mode-layout[]"
                                           value="grid" data-list-mode="grid"
                                           @change="setLayoutMode"
                                    >
                                    <label for="list-mode-layout_grid" class="icon-list-mode list-mode_grid">
                                        <span class="sr-only">Afficher en mode "mosaïque"</span>
                                        <span class="icons">
                                            <i class="fa-solid fa-grid" aria-hidden="true"></i>
                                            <i class="fa-light fa-grid" aria-hidden="true"></i>
                                        </span>
                                    </label>
                                </div>

                                <div class="list-mode-group d-none d-md-block">
                                    <input type="radio" id="list-mode-layout_list" name="list-mode-layout[]"
                                           value="list" data-list-mode="list"
                                           @change="setLayoutMode"
                                           checked
                                    >
                                    <label for="list-mode-layout_list" class="icon-list-mode list-mode_list">
                                        <span class="sr-only">Afficher en mode "liste"</span>
                                        <span class="icons">
                                            <i class="fa-regular fa-table-list" aria-hidden="true"></i>
                                            <i class="fa-light fa-list" aria-hidden="true"></i>
                                        </span>
                                    </label>
                                </div>

                            </div>
                            <div class="list-mode-group d-flex align-items-center-md list-mode-order-container">
                                <button class="filters-toggle filters-toggle-btn filter-toggle-mobile d-xl-none"
                                        ref="btnToggleFilters"
                                        @click="toggleFiltersOpen"
                                        :aria-label=" openCloseFiltersText "
                                >
                                    <i class="fa-light fa-sliders" aria-hidden="true"></i>
                                    <span class="filter-toggle-label ms-2">{{
                                            copydeck?.search?.filters?.fr ?? 'copydeck?.search?.filters?.fr'
                                        }}</span>
                                </button>
                                <label for="list-mode-order" class="select-label">{{
                                        copydeck?.search?.tri?.fr ?? 'copydeck?.search?.tri?.fr'
                                    }}</label>
                                <div class="custom-select small">
                                    <div class="select-container">
                                        <select name="list-mode-order"
                                                id="list-mode-order"
                                                ref="orderSelect"
                                                @change="adjustSortOrder"
                                                class="custom-select">
                                            <option value="date" selected>Date</option>
                                            <option value="alpha">Titre</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr/>
                        <div class="results-info">
                            <div class="num-results" v-if="numArticles > 0">
                                <span class="value">{{ numArticles }}</span>
                                <span class="unit">{{ articlesPluralSingularWord }}</span> -
                                <span class="">Page {{ (pagination.currentPage + 1) }} de {{
                                        pagination.totalPages
                                    }}</span>
                            </div>
                            <!--                        @endif-->
                            <div class="keywords-list d-flex align-items-center flex-wrap">
                                <div class="keyword-link gray me-2" v-for="filter in currentFilters" :key="filter.id">
                                    {{ filter.title }}
                                    <button type="button" class="ms-2"
                                            @click.prevent="unchecked(filter.type, filter.id)"
                                            @keyup.enter="unchecked(filter.type, filter.id)"
                                            @keyup.space="unchecked(filter.type, filter.id)"
                                            :aria-label="'Retirer le filtre' + filter.title "
                                    ><i class="fa-light fa-xmark" aria-hidden="true"></i></button>
                                </div>
                            </div>
                        </div>

                        <div class="results row" v-if="ready && pagination.numResults > 0 " :class="layoutMode">
                            <div class="articles-card-grid">

                                <Article
                                    v-for="(foundArticle, index) in filteredArticles"

                                    :article="foundArticle"></Article>

                            </div>
                        </div>

                        <!--    no results-->
                        <NoResults v-if="ready && pagination.numResults === 0"/>

                    </section>

                    <Pagination/>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name : 'Articles Module',
}
</script>

<script setup>


import { computed, inject, nextTick, onMounted, ref } from 'vue';
import { useStore }                                   from "vuex";
import NoResults                                      from './NoResults';
import Filter                                         from './Filter';
import Article                                        from './Article';
import { uniqueId, chunk, debounce }                  from "lodash-es";
import Pagination                                     from './Pagination';

let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

const emit = defineEmits( [
    'changedFilter',
] );

let pagination = computed( () => store.getters.pagination );

let articles         = computed( () => store.getters.articles );
let filteredArticles = computed( () => store.getters.filteredPaginatedArticles[ pagination?.value?.currentPage ?? 0 ] );
let numArticles      = computed( () => store.getters.filteredArticles.length );


let categories = computed( () => store.getters.categories );
let pageTitle  = computed( () => store.getters.pageTitle );

let allFilters = computed( () => store.getters.allFilters );

let filtersOpen         = ref( null );
let btnToggleFilters    = ref( null );
let filtersPanel        = ref( null );
let filterToggleTimeout = ref( null );

let layoutMode = computed( () => 'list-display-mode_' + store.getters.layoutMode )

//THESES SHOUDL HAVE BEEN computed, but it would need a complete re-write to fix it
let currentCategoriesFilters = ref( [] )
let currentDateFilters       = ref( [] )
let currentFilters           = ref( [] )
///////////////////////////////////////////////////

let orderSelect = ref( null );

let ready = computed( () => store.getters.appReady );


// a11y
let openCloseFiltersText = computed( () =>
{

    console.log( 'Inside computed openCloseFiltersText', filtersOpen.value, copydeck.value.search.a11yFiltersHide.fr, copydeck.value.search.a11yFiltersShow.fr )

    return filtersOpen.value
        ? (copydeck?.value?.search?.a11yFiltersHide?.fr ?? 'copydeck.search.a11yFiltersHide.fr')
        : (copydeck?.value?.search?.a11yFiltersShow?.fr ?? 'copydeck.search.a11yFiltersShow.fr');
} );

function mounted ()
{

    let copydeck   = inject( "copydeck" );
    let articles   = inject( "articles" );
    let categories = inject( "categories" );
    let pageTitle  = inject( "pageTitle" );

    store.commit( "copydeck", copydeck )
    store.commit( "articles", articles );
    store.commit( "categories", categories );
    store.commit( "pageTitle", pageTitle );

    store.commit( "resetFilters" );


    maybePreFilterBasedOnUrl();

    filterArticles();

    detectMobileMode();

    // only the first time
    // We need the filters to be shown/open on desktop,
    // but we need to close them on mobile
    if ( filtersOpen.value === null )
    {
        filtersOpen.value = store.getters.isMobile ? false : true;

        if ( !filtersOpen.value )
        {
            nextTick( () =>
            {
                filtersPanel.value.classList.add( 'closed' );
            } )
        }
    }

    window.addEventListener( 'resize', debouncedDetectMobile );


    store.dispatch( 'appReady', true );


}


function detectMobileMode ()
{


    const windowWidth = window.innerWidth;
    const isMobile    = windowWidth < 1200; // based on the XL breakpoint in CSS

    store.commit( "setMobileMode", isMobile );

/*console.log(( 'Setting mobile mode. isMobile = ' + isMobile ))*/;}

let debouncedDetectMobile = debounce( detectMobileMode, 300 );

let articlesPluralSingularWord = computed( () =>
{


    return numArticles.value === 1 ?
        copydeck?.value?.search?.resultat_singulier?.fr ?? 'copydeck?.search?.resultat_singulier.fr ' :
        copydeck?.value?.search?.resultat_pluriel?.fr ?? 'copydeck?.search?.resultat_pluriel?.fr  ';

} );


function toggleFiltersOpen ()
{

    console.log( 'About to toggle the filters. Currently, they are ' + (filtersOpen.value ? 'open' : 'closed') )

    if ( filterToggleTimeout.value )
    {
        clearTimeout( filterToggleTimeout.value );
    }

    // open -> closing
    if ( filtersOpen.value )
    {
        filtersPanel.value.classList.add( 'closing' );
        filtersOpen.value = false;

        filterToggleTimeout.value = setTimeout( () =>
        {
            filtersPanel.value.classList.add( 'closed' );
        }, 200 );


/*console.log(( 'Article filters... filtersOpen: ', filtersOpen ))*/;
    } else

        // closed -> open
    {
        filtersPanel.value.classList.remove( 'closed' );
        filtersOpen.value = true;

        filterToggleTimeout.value = setTimeout( () =>
        {
            filtersPanel.value.classList.remove( 'closing' );
        }, 200 )

/*console.log(( 'Article filters... filtersOpen: ', filtersOpen ))*/;
    }

}

function resetFilters ()
{
    store.commit( "resetFilters" );

    filterArticles();
}


function filterArticles ()
{


    /**
     * Gather Filters
     */

    let checkedCategories     = [];
    let checkedCategoriesFull = [];
    let checkedDates          = [];
    let checkedDatesFull      = [];


    allFilters.value.categories.forEach( cat =>
    {
        if ( cat.active )
        {
            checkedCategories.push( cat.id );
            checkedCategoriesFull.push( Object.assign( cat, { type : 'category' } ) );
        }
    } );


    allFilters.value.dates.forEach( date =>
    {
        if ( date.active )
        {
            checkedDates.push( date.value );
            checkedDatesFull.push( Object.assign( date, { type : 'date' } ) );
        }
    } );

    if ( checkedCategories.length === 0 && checkedDates.length === 0 )
    {
        // no filters, all of the articles

        const articlesToSort = sortArticles( articles.value );

        adjustPagination( articlesToSort );

        currentCategoriesFilters.value = checkedCategoriesFull;
        currentDateFilters.value       = checkedDatesFull;

        currentFilters.value = [ ...currentCategoriesFilters.value, ...currentDateFilters.value ];

        return;
    }


    /**
     * Filters articles
     */
    let wantedArticles = articles.value.filter( article =>
    {

        let shouldReturn = false;

        let matchCategory = true;

        if ( checkedCategories.length > 0 )
        {
            matchCategory = (checkedCategories.includes( article.catCleanedId ))
        }


        let matchDate = true;
        if ( checkedDates.length > 0 )
        {
            matchDate = false;

            checkedDates.forEach( date =>
            {

                if ( date === 'all' )
                {
                    matchDate = true;
                }

                if ( date >= article.publishedDaysAgo )
                {
                    matchDate = true;
                }


            } )
        }


        // Alll should probably negate any other date filter
        if ( matchCategory && matchDate )
        {
            shouldReturn = true;
        }


        return shouldReturn;
    } );


    /**
     * Sort the results
     */
    wantedArticles = sortArticles( wantedArticles );


    adjustPagination( wantedArticles );


    currentCategoriesFilters.value = checkedCategoriesFull;
    currentDateFilters.value       = checkedDatesFull;

    currentFilters.value = [ ...currentCategoriesFilters.value, ...currentDateFilters.value ];

}


function sortArticles ( articles )
{


    // empty? Nothing to do
    if ( articles.length < 1 )
    {
        return articles;
    }

    if ( 'alpha' === store.getters.sortOrder )
    {
        articles.sort( ( a, b ) => a.safeTitle.localeCompare( b.safeTitle ) )

    } else
    {
        articles.sort( ( a, b ) => new Date( b.publish_start.replace( " ", "T" ) ).getTime() - new Date( a.publish_start.replace( " ", "T" ) ).getTime() ); //IOS NEED THE "T"
    }

    return articles;
}

function adjustSortOrder ( event )
{

    store.commit( "sortOrder", event.target.value );

    filterArticles();
}


function maybePreFilterBasedOnUrl ()
{

    let params = new URLSearchParams( window.location.search ).getAll( 'categorie' );

    if ( !params )
    {
        return;
    }


    // clean the ids
    params = params.map( par =>
    {
        return parseInt( par );
    } );

    // pre-activate categories
    params.forEach( p =>
    {
        store.commit( "forceActivateCategory", p );
    } )


}


function adjustPagination ( wantedArticles )
{

    if ( !pagination.value.resultsPerPage || wantedArticles.length < 1 )
    {
        store.commit( "filteredArticles", wantedArticles );
        store.commit( "filteredPaginatedArticles", wantedArticles );

        store.commit( "pagination", {
            currentPage      : 0,
            hasMultiplePages : false,
            lastPage         : 0,
            numResults       : wantedArticles?.length ?? 0,
            resultsPerPage   : pagination.value.resultsPerPage,
            totalPages       : 0,
        } );

    }


    const chunkedArticles = _.chunk( wantedArticles, pagination.value.resultsPerPage );

    store.commit( "filteredArticles", wantedArticles );
    store.commit( "filteredPaginatedArticles", chunkedArticles );


    const totalPages = chunkedArticles.length;

    store.commit( "pagination", {
        currentPage      : 0,
        hasMultiplePages : totalPages > 1,
        numResults       : wantedArticles.length,
        resultsPerPage   : pagination.value.resultsPerPage,
        totalPages       : totalPages,
        lastPage         : totalPages - 1,
        isLastPage       : false,
        isFirstPage      : true,
    } );
}

function unchecked ( filterType, id )
{


    //This is not the "Vue" way of doing this... but here we are...
/*console.log(( 'unchecked', filterType, id ))*/;    if ( filterType === "category" )
    {
        // let ch     = document.querySelector( `#category-filter_${filter.id}` );
        // ch.checked = false;

        currentFilters.value = currentFilters.value.filter( c => c.type !== "category" || c.id !== id );

        if ( allFilters?.value?.categories ?? false )
        {
            allFilters.value.categories.find( c => c.id === id ).active = false;
        }

    } else if ( filterType === "date" )
    {
        // let ch     = document.querySelector( `#date-filter_${filter.id}` );
        // ch.checked = false;

        currentFilters.value = currentFilters.value.filter( c => c.type !== "date" || c.id !== id );

        if ( allFilters?.value?.dates ?? false )
        {
            allFilters.value.dates.find( c => c.id === id ).active = false;
        }
    }


    filterArticles();
}


function setLayoutMode ( e )
{
/*console.log(( 'setLayoutMode', e.target.value ))*/;    const newMode = e?.target?.value ?? false;

    if ( newMode )
    {
        store.commit( "layoutMode", e.target.value )
    }
}

onMounted( mounted );
</script>

